import { render, staticRenderFns } from "./ContentTypeFieldEditForm.vue?vue&type=template&id=456f4d59"
import script from "./ContentTypeFieldEditForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTypeFieldEditForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports